import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home/index.vue')
  },
  {
    path: '/gift',
    name: 'gift',
    component: () => import('../views/Gift/index.vue')
  },
  // {
  //   path: '/coupon',
  //   name: 'coupon',
  //   component: () => import('../views/Coupon/index.vue')
  // },
  {
    path: '/integral',
    name: 'integral',
    component: () => import('../views/Integral/index.vue')
  },
  {
    path: '/my',
    name: 'my',
    component: () => import('../views/My/index.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
